import Card from './Card';

const TableShell = ({
    toolbar = null,
    footer = null,
    children,
    className = '',
    tableWrapClassName = 'overflow-x-auto',
}) => {
    return (
        <Card className={`!p-0 overflow-hidden ${className}`.trim()}>
            {toolbar ? <div className="p-6 border-b border-mono-200 dark:border-mono-800">{toolbar}</div> : null}
            <div className={tableWrapClassName}>{children}</div>
            {footer ? <div className="px-6 py-4 border-t border-mono-200 dark:border-mono-800">{footer}</div> : null}
        </Card>
    );
};

export default TableShell;
